export default __webpack_public_path__ + "34a0cd23df4e8e7fe48a5513be111507.gif";